export enum NodeType {
  // Blur = 'blur',
  // Channels = 'channels',
  // Crop = 'crop',
  // Masks = 'masks',
  // Media = 'media',
  // MergeAlpha = 'merge_alpha',
  // Painter = 'painter',
  // PainterV2 = 'painterV2',
  // Preview = 'preview',
  // Resize = 'resize',
  // Router = 'router',
  // Seed = 'seed',
  PromptConcat = 'prompt_concat',
  Array = 'array',
  Boolean = 'boolean',
  CustomModel = 'custommodel',
  CustomModelV2 = 'custommodelV2',
  Import = 'import',
  MediaIterator = 'media_iterator',
  Integer = 'integer',
  MultiLora = 'multilora',
  MuxV2 = 'muxv2',
  Prompt = 'promptV2',
  PromptV3 = 'promptV3',
  String = 'string',
  Target = 'target',
  WildcardV2 = 'wildcardV2',
  WorkflowOutput = 'workflow_output',
  CustomGroup = 'custom_group',
  StickyNote = 'stickynote',
  Export = 'export',
  FigmaCompositor = 'figma_compositor',
}
